import { FeedReactionType } from '@flipster/apis/v1/community/types';
import HeartBrokenIcon from '@flipster/react/icon/generated/HeartBrokenIcon';
import RocketIcon from '@flipster/react/icon/generated/RocketIcon';
import { IconProps } from '@flipster/react/icon/types';
import { Token } from '@flipster/styled-system/tokens';

interface Reaction {
  Icon: React.FunctionComponent<IconProps>;
  color: Token;
}
export const reactionTypes: FeedReactionType[] = ['ROCKET', 'BROKEN_HEART'];
export const reactions: Record<FeedReactionType, Reaction> = {
  ROCKET: {
    Icon: RocketIcon,
    color: 'colors.content.accent.info',
  },
  BROKEN_HEART: {
    Icon: HeartBrokenIcon,
    color: 'colors.content.state.negative',
  },
};
